import React from "react";
import EventCard from "./EventCard";

const Upcomingevents = ({ events = [], getEventStatus, formatDate, formatTime }) => {
  // Filter events that are either Upcoming or Ongoing
  const filteredEvents = events.filter(
    (event) => ["Upcoming", "Ongoing"].includes(getEventStatus(event.dateFrom, event.dateTo))
  );

  if (filteredEvents.length === 0) {
    return <p className="text-center">No Ongoing and Upcoming Events.</p>;
  }

  return (
    <div className="row g-4">
      {filteredEvents.map((event) => (
        <EventCard
          key={event.eventId || event.id} // fallback key
          event={event}
          getEventStatus={getEventStatus}
          formatDate={formatDate}
          formatTime={formatTime}
        />
      ))}
    </div>
  );
};

export default Upcomingevents;
